import { React, useEffect } from 'react';
import { Box, Card, CardBody, CardHeader, Grid, GridItem, Image, Link, Stack, Text, VStack, Button, Spinner, Center } from '@chakra-ui/react'
import { AnnouncementsHomePanel, Footer, MarkdownRenderer, WithSubnavigation, WeatherWidget } from '../../Components';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
} from '@chakra-ui/react'

const setCookie = (name, value, days) => {
  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + days);
  document.cookie = `${name}=${value}; expires=${expirationDate.toUTCString()}; path=/`;
}

const getCookie = (name) => {
  const cookies = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${name}=`));

  return cookies ? cookies.split("=")[1] : null;
};

const showModal = false; // OW Ervin Memorial Match popup - set to true for next year's event

export const Home = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const masthead = {
    title: "Golden Gun Club",
    subtitle: "Denver Metro's Premier Shooting Facility",
    image: "https://ggc-website-public-content.s3.amazonaws.com/images/masthead-home.jpg"
  };

  const sections = [
    {
      heading: "Facilities for All Types of Shooters and Shooting Sports",
      content: "Golden Gun Club offers its Members access to a large shooting facility just minutes from the Denver Metro Area, with a wide variety of shooting opportunities. Our rifle range is exclusively available to members only, except for Match Programs which are open to the public, or unless a scheduled event is listed on our calendar. The range features 3 ranges with 75 total firing points, offering target distances from 10 feet to 500 yards for hunters, target shooters, and competitors to hone their skills. In contrast, the shotgun facilities—featuring Trap, Skeet, and 5-Stand shooting—are open to the public, though members receive discounts on target fees. These facilities cater to casual shooters, bird hunters preparing for the season, and competitive Trap or Skeet shooters alike.",
      video: "https://ggc-website-public-content.s3.amazonaws.com/videos/golden-gun-club-videoshoot.mp4",
      mediaType: "video"
    },
    {
      heading: "Match Programs for Both  Novice or Competitive Shooters",
      content: "The shooting sports have a storied tradition across the United States, and Golden Gun Club seeks to continue to offer these enjoyable competitive and recreational programs to shooters in the Denver Metro area.\nGolden Gun Club offers several match programs in a variety of disciplines. Matches are open to the public and to all Members. These matches are approachable and engaging for all skill levels, and offer a fun way to add another dimension to your shooting experience.\nThe club invites all shooters across the Metro Area to check out our matches, regardless of experience!",
      image: "https://ggc-website-public-content.s3.amazonaws.com/images/range.jpg"
    },
    {
      heading: "Best-in-Class Shotgun Facilities",
      content: "The Club has two dedicated Trap fields, six combination Skeet and Trap fields and a 5 Stand field sprawling across a 160-acre facility. We offer weekly Trap league shooting as well as monthly registered shooting for ATA and NSSA. Check out our monthly calendar for event dates.",
      image: "https://ggc-website-public-content.s3.amazonaws.com/images/facilities.jpg"
    }
  ];

  useEffect(() => {
    const cookieval = getCookie("hasclosedmodal");
    if (cookieval !== "y") {
      onOpen();
    }
  }, [onOpen]);

  const closeModal = () => {
    setCookie("hasclosedmodal", "y", 1)
    onClose();
  };

  const renderMedia = (section) => {
    if (section.mediaType === 'video' && section.video) {
      return (
        <Box w="100%" h="auto">
          <video
            width="100%"
            height="auto"
            controls
            style={{ borderRadius: '8px' }}
            poster={section.image} // Use image as poster if available
          >
            <source src={section.video} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </Box>
      );
    } else {
      return <Image src={section.image} borderRadius="8px" />;
    }
  };

  return (
    <>
      {showModal && (
        <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={closeModal}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>In Honor of O.W. Ervin, GySgt U.S.M.C. (ret)</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <Box>
                <Text style={{
                  textAlign: 'center',
                  fontWeight: 'normal',
                  fontStyle: 'italic',
                  fontSize: 18
                }}>3rd Annual GySgt O.W. Ervin, U.S.M.C. Memorial National Match</Text>
                <Text style={{
                  textAlign: 'center',
                  fontWeight: 'normal',
                  fontStyle: 'italic',
                  fontSize: 18,
                  marginTop: '40px'
                }}>Presented by Golden Gun Club (CO)</Text>
                <Text style={{
                  textAlign: 'center',
                  fontWeight: 'bold',
                  fontSize: 16,
                  marginTop: '40px'
                }}>Join us for our 3rd annual celebration of our benefactor, longtime president and prior co-match director of Service Rifle at Golden Gun Club.</Text>
                <Text style={{
                  textAlign: 'center',
                  fontWeight: 'bold',
                  fontSize: 16,
                  marginTop: '40px'
                }}>WHAT: CMP-Sanctioned Highpower 100y-Reduced 50 Round CMP/NRA National Match Course</Text>
                <Text style={{
                  textAlign: 'center',
                  fontWeight: 'bold',
                  fontSize: 16
                }}>$12 entry fee (members) / $15 entry fee (guests)</Text>
                <Text style={{
                  textAlign: 'center',
                  fontWeight: 'bold',
                  fontSize: 16,
                  marginTop: '20px'
                }}>WHEN: July 18, 2026 - Registration 0800 - Briefing 0845 - First Shots 0900</Text>
                <Text style={{
                  textAlign: 'center',
                  fontWeight: 'bold',
                  fontSize: 16,
                  marginTop: '20px'
                }}>WHERE: Golden Gun Club (central range) - 1503 Watkins Road, Watkins CO 80137</Text>
                <Text style={{
                  textAlign: 'center',
                  fontWeight: 'bold',
                  fontSize: 16,
                  marginTop: '20px'
                }}>WHO: Members and Public Welcome!</Text>
                <Text style={{
                  textAlign: 'center',
                  fontWeight: 'normal',
                  fontStyle: 'italic',
                  fontSize: 16,
                  marginTop: '40px'
                }}>Questions? Comments? Contact the Match Director:</Text>
                <Text style={{
                  alignItems: 'center',
                  fontWeight: 'normal',
                  fontStyle: 'italic',
                  fontSize: 16
                }}>competitions@goldengunclub.us</Text>
              </Box>
            </ModalBody>
            <ModalFooter>
              <Button onClick={closeModal}>Close</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
      <Box bg="#F7F7F7">
        <WithSubnavigation />
        <Box>
          <Box pos="relative">
            <Image pt={{ base: "86px", md: "0" }} w="100%" src={masthead.image} alt='' />
            <Box
              bottom={{ md: '35%' }}
              pos={{ base: 'static', md: 'absolute' }}
              px={{ base: '42px', md: '84px' }}
            >
              <Text as="h1" color="#FD5521" fontSize={{ base: '40px', md: '60px' }} fontWeight="700">{masthead.title}</Text>
              <Text as="h2" mb="40px" color={{ base: '#000', md: '#000' }} fontSize={{ base: '21px', md: '35px' }} fontWeight="700">{masthead.subtitle}</Text>
              <Stack spacing={6} direction={{ base: 'column', md: 'row' }}>
                <Link href="/membership" bg="#FD5521" color="#FFF" p="22px 32px" fontWeight="600" borderRadius="6px" textAlign="center">View Membership Details</Link>
                <Link href="/matches-competition" bg="#FD5521" color="#FFF" p="22px 32px" fontWeight="600" borderRadius="6px" textAlign="center">View Match Programs</Link>
                <Link href="/about-us" bg="#FD5521" color="#FFF" p="22px 32px" fontWeight="600" borderRadius="6px" textAlign="center">Contact Us</Link>
              </Stack>
            </Box>
          </Box>
          <Box id="main">
            <WeatherWidget />
            <Grid gap={10} m="24px 0" px={{ base: '42px', md: '84px' }} templateColumns={{ base: 'repeat(12, 1fr)' }}>
              <GridItem colSpan={{ base: 12, lg: 8 }} mt={{ base: 4, md: 8 }}>
                {sections.map((section, index) => index % 2 === 0 ? (
                  <Box key={index}>
                    <Stack
                      spacing='24px'
                      direction={{ base: 'column', md: 'row' }}
                    >
                      <Box w={{ base: '100%', md: '40%' }}>
                        <Text as="h2" mb="40px" fontSize={{ base: '24px', md: '36px' }} fontWeight="700">{section.heading}</Text>
                        <Box>
                          <MarkdownRenderer children={section.content} />
                        </Box>
                      </Box>
                      <Box w={{ base: '100%', md: '60%' }}>
                        {renderMedia(section)}
                      </Box>
                    </Stack>
                  </Box>
                ) : (
                  <Box m="24px 0" key={index}>
                    <Stack
                      spacing='24px'
                      direction={{ base: 'column', md: 'row' }}
                    >
                      <Box w={{ base: '100%', md: '50%' }}>
                        {renderMedia(section)}
                      </Box>
                      <Box w={{ base: '100%', md: '50%' }}>
                        <Text as="h2" mb="40px" fontSize={{ base: '24px', md: '36px' }} fontWeight="700">{section.heading}</Text>
                        <Box>
                          <MarkdownRenderer children={section.content} />
                        </Box>
                      </Box>
                    </Stack>
                  </Box>
                ))}
              </GridItem>
              <GridItem colSpan={{ base: 12, lg: 4 }} mt={{ base: 4, md: 8 }}>
                <AnnouncementsHomePanel />
              </GridItem>
            </Grid>

          </Box>
        </Box>
        <Footer />
      </Box>
    </>
  );
}
